import React, { useState } from "react";
import parse from "html-react-parser";
import { Link } from 'react-router-dom';
import YTPlayer from "../youtubePlayer/YTPlayer";

import back from '../../assets/images/back-arrow.svg';

import TProzoKrivinContent from '../../assets/data/tradukita_prozo/feliks_krivin';
import TKantojMatveeva from '../../assets/data/tradukitaj_kantoj/bardaj_kantoj_de_vera_matveeva';

const langs = {
  esp: 'ESP',
  ru: 'RUS'
}

const opts = {
  width: '640',
  playerVars: {
    controls:1,
    playsinline:1,
    modestbranding:1,
    autohide:0,
    showinfo:0,
    rel:0,
    showsearch:0,
    fs:0,
    disablekb:1,
    enablejsapi:1,
    webkitPlaysinline:1,
    iv_load_policy:1,
    },
};
const dynamicComponents = {
  TProzoKrivinContent,
  TKantojMatveeva
};
const ArticlePage = (p) => {
  const [action, store] = [p.action, p.store];

  const [lang, setLang] = useState("esp");

  const updateLink = (link) => {
    store.currentText != null && action('UPDATE_CURRENT_TEXT', null);
    action('UPDATE_LINK', link);
  }

  const updateLang = (v) => {
    setLang(v);
  }
  const getArticleComponent = (article) => {
    var MyComponent = dynamicComponents[article.itemContentName];
    return React.createElement(MyComponent, {...p});
  }
  let currentCategory = decodeURIComponent(window.location.pathname.split('/')[1]);
  let currentArticle = decodeURIComponent(window.location.pathname.split('/')[2]);
  if ( currentCategory.startsWith('ruslingvaĵoj') ) {
    currentCategory = 'ruslingvaĵoj/'+decodeURIComponent(window.location.pathname.split('/')[2]);
    currentArticle = window.location.pathname.split('/')[3] && decodeURIComponent(window.location.pathname.split('/')[3]);
  }

  const item = (!store || !store.siteData || !store.siteData.itemsList)
    ? null
    : store.siteData.itemsList.get(currentCategory).find(i => i.itemlink === currentArticle);

  const article = item?.[currentCategory.startsWith('ruslingvaĵoj') ? 'rus' : lang];
  
  const getArticleContentClass = () => {
    return (
      "article-page page-content" + ( article.isReactComponent ? ' no-padding-bottom' : '')
    )
  }

  const articleContent = () => {
    return (
      !article ? null :
        <div className="article-content-item">
          {article.isReactComponent ? 
            getArticleComponent(article) : 
            parse(article.itemContent)
          }
        </div>
    )
  }
  const articleLangSwitcher = () => {
    let availableLangs = [];
    let item = store.siteData.itemsList.get(currentCategory).find(i => i.itemlink === currentArticle);
    for (let key in item) {
      if (langs[key]) availableLangs.push({value: key, label: langs[key]});
    }
    return (availableLangs.length > 1 ? 
      <div className="lang-switcher-block">
        { availableLangs.map((item, index) => (
          <span key={'lang_'+index} onClick={()=>updateLang(item.value)} className={'lang-switcher-item' + (item.value === lang ? ' lang-switcher-item-active' : '')}>
            {item.label}
          </span>
        )) } 
      </div> : null ) 
  }
  const articleAuthor = () => {
    return !article.itemAuthor ? null : <p className="article-author"><span>{ parse (article.itemAuthor) }</span></p>
  }

  const articleTranslator = () => {
    return !article.itemTranslator ? null : <p className="article-translator"><span>{ parse (article.itemTranslator) }</span></p>
  }

  const articleBookInfo = () => {
    return !article.itemBookInfo ? null : 
    <div className="article-content-item">
      <p className="article-bibliografio kanto mb-4">
        <span className="article-bibliografio-name kanto-legend">{article.itemBookInfo.bookName}</span>
        <span className="article-bibliografio-content">{ parse (article.itemBookInfo.content) }
        </span>
      </p>
    </div>
  }

  const articleDate = () => {
    return !article.itemDate ? null : <p className="article-date"><span>{article.itemDate}</span></p>
  }

  const articlePlace = () => {
    return !article.itemPlace ? null : <p className="article-place"><span>{article.itemPlace}</span></p>
  }

  const articleVideo = () => {
    return !article.itemVideo ? null : (
      <div className="flex flex-center flex-column text-center auto-resizable-iframe">
        {article.itemVideo.map(i => <YTPlayer videoid={i} opts={opts} ></YTPlayer> )}
      </div>
    )
  }
  return ( 
    ( !article ? null : 
      <div className={getArticleContentClass()}>
        <div className="flex page-header">
        {!item?.hideBackButton && (
          <Link className="back-to-list" to={'/'+currentCategory} onClick={() => updateLink('/'+currentCategory)}>
            <img src={back} alt="Reen" />
          </Link>
        )}
          
          <h2 className="text-center">{article.itemName}</h2>
        </div>
        {articleLangSwitcher()}
        {articleTranslator()}
        {articleBookInfo()}
        {articleContent()}
        {articleVideo()}
        {articleAuthor()}
        {articleDate()}
        {articlePlace()}
      </div>
    )
  )
}


export default ArticlePage;